import React from 'react'
import intl from 'react-intl-universal'

import { ComposerSettings } from '~/types'
import ModuleWrapper from '../ModuleWrapper'
import TansaSettings from './TansaSettings'
import ProLexisSettings from './ProLexisSettings'
import ArcXpSpellcheckSettings from './ArcXpSpellcheckSettings'
import { useEvidentlyFeatures } from '~/evidentlyFeatureFlags'
import { EVIDENTLY_FLAG } from '~/util/constants/keys'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./ProofreaderSettings.styles.scss')

interface Props {
  proofreaderSettings: ComposerSettings['proofreaders']
  websites: Array<{
    _id: string
    display_name: string
  }>
  onChange: (proofreaderSettings: ComposerSettings['proofreaders']) => void
}

const ProofreaderSettings: React.FC<Props> = (props) => {
  const features = useEvidentlyFeatures()
  function handleRadioChange(event: React.ChangeEvent<HTMLInputElement>) {
    props.onChange({
      ...props.proofreaderSettings,
      active: event.target.value as 'tansa' | 'proLexis' | 'arcSpellcheck',
    })
  }

  return (
    <ModuleWrapper title={intl.get('ProofreaderSettings.title')}>
      <p className={styles.description}>
        {intl.get('ProofreaderSettings.description')}
      </p>

      <div className={`d-flex py-4 ${styles.radios}`}>
        <div className="mr-5">
          <input
            type="radio"
            id="proofreader-tansa"
            name="proofreader"
            value="tansa"
            checked={props.proofreaderSettings.active === 'tansa'}
            onChange={handleRadioChange}
          />
          <label htmlFor="proofreader-tansa" className="m-0">
            {intl.get('ProofreaderSettings.tansa')}
          </label>
        </div>
        <div className="mr-5">
          <input
            type="radio"
            id="proofreader-proLexis"
            name="proofreader"
            value="proLexis"
            checked={props.proofreaderSettings.active === 'proLexis'}
            onChange={handleRadioChange}
          />
          <label htmlFor="proofreader-proLexis" className="m-0">
            {intl.get('ProofreaderSettings.proLexis')}
          </label>
        </div>
        {features && features[EVIDENTLY_FLAG.ARC_SPELLCHECKER] && (
          <div className="arcSpellcheck">
            <input
              type="radio"
              id="proofreader-arcSpellcheck"
              data-testid="proofreader-arcSpellcheck"
              name="proofreader"
              value="arcSpellcheck"
              checked={props.proofreaderSettings.active === 'arcSpellcheck'}
              onChange={handleRadioChange}
            />
            <label htmlFor="proofreader-arcSpellcheck" className="m-0">
              {intl.get('ProofreaderSettings.arcSpellcheck')}
            </label>
            <div>Beta</div>
          </div>
        )}
      </div>

      {props.proofreaderSettings.active === 'tansa' && (
        <TansaSettings
          {...props.proofreaderSettings.tansa}
          websites={props.websites}
          onChange={(tansaSettings) => {
            props.onChange({
              ...props.proofreaderSettings,
              tansa: tansaSettings,
            })
          }}
        />
      )}
      {props.proofreaderSettings.active === 'proLexis' && (
        <ProLexisSettings
          {...props.proofreaderSettings.proLexis}
          onChange={(proLexisSettings) => {
            props.onChange({
              ...props.proofreaderSettings,
              proLexis: proLexisSettings,
            })
          }}
        />
      )}
      {features &&
        features[EVIDENTLY_FLAG.ARC_SPELLCHECKER] &&
        props.proofreaderSettings.active === 'arcSpellcheck' && (
          <ArcXpSpellcheckSettings
            {...props.proofreaderSettings.arcSpellcheck}
            onChange={(arcSpellcheck) => {
              props.onChange({
                ...props.proofreaderSettings,
                arcSpellcheck: arcSpellcheck,
              })
            }}
          />
        )}
    </ModuleWrapper>
  )
}

export default ProofreaderSettings
